export const convertPriceToPounds = (price) => {
  return price / 100
}
